module.exports = __webpack_public_path__ + "static/media/8@3x.9428a1c1.png";